<template>
  <div>
    <b-row>
      <b-col cols="12">
        <FITWorkflowProgressbar ref="progressBar" :startingIndex="nextStep" :steps="workflow"></FITWorkflowProgressbar>
      </b-col>
    </b-row>
    <b-row align-h="center">
      <b-col cols="12">
        <router-view></router-view>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import {
  FITWorkflowProgressbar
} from '@/components'

import {
  ServiceRequestCreate
} from '../components'

import {
  mapState
} from 'vuex'

export default {
  name: 'ServiceRequestCreate',
  components: {
    FITWorkflowProgressbar,
    ServiceRequestCreate
  },

  computed: {
    ...mapState('ServiceRequest', ['nextStep'])
  },

  watch: {
    nextStep(val, old) {
      let diff = old - val;

      if (diff > 0) { // prev
        for (let i = 0; i < diff; i++) {
          this.$refs.progressBar.prevTab();
        }
      } else {
        diff = diff * -1;
        for (let i = 0; i < diff; i++) {
          this.$refs.progressBar.nextTab();
        }
      }
    }
  },

  data() {
    return {
      workflow: [
        { name: this.$t('osm.serviceRequest.workflow-1') },
        { name: this.$t('osm.serviceRequest.workflow-2') },
      ]
    }
  },

  created() {
    // console.debug('created', nextStep);
    // console.debug('ServiceRequestCreateWorkflow', this.ID);
  },

  destroyed() {
    this.$store.commit({ type: 'ServiceRequest/setNextStep', nextStep: 0 })
    this.$store.commit({ type: 'ServiceRequest/setServiceRequestStatus', serviceRequestStatus: null })
  }


}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/containers/ServiceRequestCreateWorkflow.vue